module.exports = __webpack_public_path__ + "static/media/home_hero_rush_site.9c6b5156.jpg";